import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const SurveyQuestionGroupTaskDefinition: TaskDefinition<'SurveysQuestionGroupToAnswerIdentifier'> =
  {
    taskableTypename: 'SurveysQuestionGroupToAnswerIdentifier',
    getUrl: ({ navigation, info }) => {
      if (info.formType === 'enps') {
        return navigation.engagement.enps.answers.fullPath()
      }

      if (!info.formId) return null
      return navigation.processes.surveys.id.answer.fullPath({ id: info.formId })
    },
    getTitle: ({ info }) => {
      if (info.formType === 'enps') {
        return i18n.t('tasks.inbox.titles.survey_question_group_enps')
      }

      return i18n.t('tasks.inbox.titles.survey_question_group', { name: info.formName })
    },
  }
